import { useState } from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { Link } from "react-router-dom";
import {
    HistoricoProfessionalIcon,
    PropositoIcon,
    FormacionIcon,
    CulturaIcon,
    SalarioIcon,
    HabilidadesIcon,
    MotivacionesIcon,
    DesempenoIcon,
    EntrenamientoIcon,
    PresentationIcon,
} from "../../../../Icons/CollaboratorsIcons";
import { FaUserEdit } from "react-icons/fa";
import { wheelCollaboratorTranslate } from "../../../../i18n/translatedMessages";

import "./wheel.sass";

const itens = [
    {
        id: 1,
        name: wheelCollaboratorTranslate.professionalHistoric,
        icon: <HistoricoProfessionalIcon />,
        link: "/candidate/professionalinfo",
    },
    {
        id: 2,
        name: wheelCollaboratorTranslate.purpose,
        icon: <PropositoIcon />,
        link: "/candidate/proposito",
    },
    {
        id: 3,
        name: wheelCollaboratorTranslate.formation,
        icon: <FormacionIcon />,
        link: "/candidate/formationinfo",
    },
    {
        id: 4,
        name: wheelCollaboratorTranslate.culture,
        icon: <CulturaIcon />,
        link: "/candidate/climaycultura",
    },
    {
        id: 5,
        name: wheelCollaboratorTranslate.salary,
        icon: <SalarioIcon />,
        link: "/candidate/salaryinfo",
    },
    {
        id: 6,
        name: wheelCollaboratorTranslate.habilities,
        icon: <HabilidadesIcon />,
        link: "/candidate/habilidades",
    },
    {
        id: 7,
        name: wheelCollaboratorTranslate.motivacions,
        icon: <MotivacionesIcon />,
        link: "/candidate/motivaciones",
    },
    {
        id: 8,
        name: wheelCollaboratorTranslate.referencias,
        icon: <DesempenoIcon />,
        link: "/candidate/references",
    },
    {
        id: 9,
        name: wheelCollaboratorTranslate.training,
        icon: <EntrenamientoIcon />,
        link: "/candidate/entrenamiento",
    },
    {
        id: 10,
        name: wheelCollaboratorTranslate.presentacion,
        icon: <PresentationIcon />,
        link: "/candidate/presentation",
    },
];

const WheelColaboradores = ({ employeeImg, handleMenu }) => {
    const [img] = useState(
        "https://assets.mydna.company/profile-placeholder.png?1654276597528"
    );
    return (
        <div className={`container-wheel-colaboradores`}>
            <div className="ring-one p-md-5 p-4">
                {itens.map((service) => {
                    return (
                        <Link
                            to={service.link}
                            className={`icons-colaboradores shadow`}
                            key={service.id}
                            data-option={service.id}
                            onClick={handleMenu}
                        >
                            {service.icon}
                            <div className="box-info">
                                <span className="title-colaboradores">
                                    {service.name}
                                </span>
                                <span className="detail-colaboradores">
                                    {service.description}
                                </span>
                            </div>
                        </Link>
                    )
                })}

                <div className="ring-two p-md-5 p-4">
                    <Link
                        className="wheelEmployeeLink-editProfile"
                        to={"/candidate/edit-profile"}
                    >
                        <img
                            src={employeeImg ? employeeImg : img}
                            alt=""
                            className="img-fluid img"
                        />
                        <span className="wheelEmployeeImgHover-editProfile">
                            <FaUserEdit size={30} />
                            {wheelCollaboratorTranslate.editProfile}
                        </span>
                    </Link>
                </div>
            </div>
        </div>
    );
};
export default WheelColaboradores;
